var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/Background.tsx
import { FlexRow } from "@xylabs/react-flexbox";
import React from "react";
var Background = /* @__PURE__ */ __name((props) => {
  return /* @__PURE__ */ React.createElement(FlexRow, props);
}, "Background");

// src/components/Breadcrumbs/BreadcrumbsEx.tsx
import { Breadcrumbs, Link } from "@mui/material";
import { assertEx } from "@xylabs/assert";
import { FlexRow as FlexRow2 } from "@xylabs/react-flexbox";
import React2 from "react";
import { Link as RouteLink } from "react-router-dom";
var getPartialPath = /* @__PURE__ */ __name((pathParts, index) => {
  const result = [];
  for (let i = 0; i <= index; i++) {
    result.push(`${pathParts[i]}/`);
  }
  return result.join("");
}, "getPartialPath");
var BreadcrumbsEx = /* @__PURE__ */ __name(({ titles, path = document.location.pathname, separator = "|", logo, children, ...props }) => {
  const pathParts = path.split("/");
  if (pathParts.at(-1)?.length === 0) {
    pathParts.pop();
  }
  assertEx(pathParts.length - 1 === titles?.length, () => `Path/Title length mismatch: ${JSON.stringify(titles)} with ${JSON.stringify(pathParts)}`);
  return /* @__PURE__ */ React2.createElement(Breadcrumbs, {
    separator,
    ...props
  }, pathParts.map((_pathPart, index) => {
    const path2 = getPartialPath(pathParts, index);
    return /* @__PURE__ */ React2.createElement(Link, {
      title: index > 0 ? titles?.[index - 1] : "COIN",
      color: index === pathParts.length - 1 ? "textPrimary" : "inherit",
      key: path2,
      component: RouteLink,
      to: path2
    }, index > 0 ? titles?.[index - 1] : /* @__PURE__ */ React2.createElement(FlexRow2, null, typeof logo === "string" ? /* @__PURE__ */ React2.createElement("img", {
      src: logo
    }) : logo));
  }), children);
}, "BreadcrumbsEx");

// src/components/CoverProgress.tsx
import { CircularProgress, useTheme } from "@mui/material";
import { ErrorsViewer } from "@xylabs/react-error";
import { FlexGrowRow } from "@xylabs/react-flexbox";
import React3 from "react";
var CoverProgress = /* @__PURE__ */ __name((props) => {
  const { paper = true, open, opacity = 0.25, errors, onRetry } = props;
  const theme = useTheme();
  if (open) {
    return /* @__PURE__ */ React3.createElement(FlexGrowRow, {
      position: "absolute",
      margin: -1,
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      bgcolor: paper ? theme.palette.background.paper : theme.palette.background.default
    }, (errors?.length ?? 0) === 0 ? /* @__PURE__ */ React3.createElement(CircularProgress, {
      style: {
        opacity
      }
    }) : /* @__PURE__ */ React3.createElement(ErrorsViewer, {
      margin: 1,
      errors,
      onRetry
    }));
  }
  return null;
}, "CoverProgress");

// src/components/MenuEx.tsx
import { Menu, useTheme as useTheme2 } from "@mui/material";
import React4 from "react";
var MenuEx = /* @__PURE__ */ __name(({ MenuListProps, mode = "light", colorize, ...props }) => {
  const theme = useTheme2();
  const colorizeMenuListProps = colorize ? {
    sx: {
      backgroundColor: theme.palette[colorize][mode]
    }
  } : {};
  return /* @__PURE__ */ React4.createElement(Menu, {
    MenuListProps: {
      ...MenuListProps,
      ...colorizeMenuListProps
    },
    ...props
  });
}, "MenuEx");

// src/components/RedirectWithQuery.tsx
import React5, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
var RedirectWithQuery = /* @__PURE__ */ __name(({ href, to, toOptions }) => {
  const newPath = `${to}${document.location.search}`;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (href) {
      globalThis.location.href = href;
    } else {
      if (newPath !== pathname) {
        void navigate(newPath, {
          replace: true,
          ...toOptions
        });
      }
    }
  });
  return /* @__PURE__ */ React5.createElement("div", null);
}, "RedirectWithQuery");

// src/index.ts
export * from "@xylabs/react-base-page";
export * from "@xylabs/react-error";
export * from "@xylabs/react-portal";
export * from "@xylabs/react-select";
export {
  Background,
  BreadcrumbsEx,
  CoverProgress,
  MenuEx,
  RedirectWithQuery
};
//# sourceMappingURL=index.mjs.map